export enum PreferredActionType {
    Opportunity = 1,
    Validation = 2
}
